import axios from "axios";

export const apiUrl =
  process.env.NODE_ENV === "production"
    ? `${process.env.REACT_APP_API_URL}`
    : "http://localhost:3000";

// loadDocumentUrl is the base URL PaperView PDF loads document files from.
// It matches the API URL in every environment.
export const loadDocumentUrl = () => {
  return apiUrl;
};

const axiosClient = axios.create({ baseURL: apiUrl });

export default axiosClient;
